import angular from 'angular'
import './profile.service'

angular.module('pub.profile', ['pub.profile.service']).controller('ProfileCtrl', ProfileCtrl)

/** @ngInject */
function ProfileCtrl($scope, $rootScope, $state, ProfileService, UploadService, UsersService) {
  var vm = this
  vm.path = false
  vm.file = ''
  vm.img = null

  ProfileService.get().then(function(result) {
    var model = result.results
    vm.id = model.id
    vm.email = model.email
    vm.username = model.username
    if (model.img === undefined) {
      vm.img = null
    } else {
      vm.img = model.img
    }
  })

  vm.reload = function() {
    $state.go($state.current, {}, { reload: true })
  }

  vm.edit = function() {
    vm.editing = !vm.editing
  }

  vm.save = function() {
    swal(
      {
        title: 'Change username',
        text: 'Are you sure ?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          UsersService.usernameAvailable(vm.username).then(
            function() {
              UsersService.changeUsername(vm.id, { username: vm.username }).then(
                function() {
                  swal.close()
                },
                function(err) {
                  swal(err.error.message, '', 'error')
                  return false
                },
              )
            },
            function(err) {
              swal(err.error.message, '', 'warning')
              return false
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.cancel = function() {
    vm.editing = !vm.editing
  }

  var watch = $scope.$watch('vm.file', function(newVal, oldVal) {
    if (newVal === oldVal) {
      vm.path = false
      return
    }

    if (newVal === null) {
      vm.path = false
    }

    vm.path = true
    UploadService.save('users', newVal, 'img', vm.id).then(function(fileName) {
      vm.path = false
      vm.img = fileName
    })
  })

  vm.savePassword = function() {
    ProfileService.changePassword({ password: vm.password }).then(function() {
      toastr.success('Saved!')
      $('#myModal').modal('hide')
    })
  }

  $scope.$on('$destroy', function() {
    watch()
  })
}
